import i18n from 'src/lib/i18n/i18n';
import { Shield } from './Icons';

export function EncryptedLabel() {
  return (
    <div class="encrypted">
      <Shield />
      {i18n('komojuHostedFields.secureText').replace(`✅`, '')}
    </div>
  );
}
